import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import ListaEspecialidades from "../ListaEspecialidades";
import {
  getEspecialidades,
  insertEspecialidad,
  changeStatusEspecialidad,
  getPermissions,
} from "../../utils/utils";
import { sections } from "../../utils/properties";

const Especialidades = ({ parentCallback, disabled }) => {
  const history = useHistory();
  let { id } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [especialidades, setEspecialidades] = useState([]);
  const [nuevaEspecialidad, setNuevaEspecialidad] = useState([]);
  const [permissions, setPermissions] = useState("");

  console.log(errors);

  useEffect(() => {
    getEspecialidades().then((especialidades) => {
      setEspecialidades(especialidades);
    });
    getPermissions().then((permissions) => {
      setPermissions(permissions);
      if (
        !(
          permissions.length > 0 &&
          permissions.some((e) => e.id_section === sections.ADMINISTRACION)
        )
      ) {
        history.push("/bienvenido");
      }
    });
  }, []);

  return (
    <div>
      {permissions.length > 0 &&
        permissions.some((e) => e.id_section === sections.ADMINISTRACION) && (
          <div>
            <div className="mt-3">
              <div className="row align-items-center">
                <div className="col-6">
                  <h1>Especialidades</h1>
                </div>
                <div className="col-6 text-end">
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    className="btn btn-warning"
                    id="myBtn"
                  >
                    Nueva especialidad
                  </button>
                </div>
              </div>
            </div>
            <div className="my-5">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th style={{ width: 0 + "%" }}>#</th>
                    <th className="col-10">Especialidad</th>
                    <th className="col-1">¿Habilitado?</th>
                  </tr>
                </thead>
                <tbody>
                  {especialidades.length > 0
                    ? especialidades.map((especialidad) => {
                        return (
                          <tr key={especialidad.esp_id}>
                            <td>{especialidad.esp_id}</td>
                            <td>{especialidad.esp_nombre}</td>
                            <td className="">
                              <div className="form-check form-switch d-flex justify-content-center">
                                <input
                                  checked={especialidad.esp_status === "1"}
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  onClick={(e) => {
                                    changeStatusEspecialidad([
                                      { id: especialidad.esp_id },
                                    ]).then(() => {
                                      getEspecialidades().then(
                                        (especialidades) => {
                                          setEspecialidades(especialidades);
                                        }
                                      );
                                    });
                                  }}
                                />
                              </div>
                              {/* <span
                          onClick={() => {
                            document.getElementById("myModal").style.display =
                              "block";
                          }}
                          className="mx-1 badge bg-primary"
                        >
                          Editar
                        </span> */}
                              {/* <a href="#">
                          <span className="mx-1 badge bg-danger">Eliminar</span>
                        </a> */}
                            </td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        )}

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Nueva especialidad
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label htmlFor="fechaAgenda">Nombre especialidad</label>
              <input
                className="form-control"
                type="text"
                id="nombreNuevaEspecialidad"
                onChange={(e) => {
                  setNuevaEspecialidad([{ name: e.target.value }]);
                }}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  insertEspecialidad(nuevaEspecialidad).then(() =>
                    getEspecialidades().then((especialidades) => {
                      setEspecialidades(especialidades);
                      document.getElementById("nombreNuevaEspecialidad").value =
                        "";
                    })
                  );
                }}
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="myModal" className="modal">
        <div className="modal-content">
          <span
            className="close text-end"
            onClick={() => {
              document.getElementById("myModal").style.display = "none";
            }}
          >
            &times;
          </span>
          <div className="card">
            <span className="card-header">
              <strong>Nueva especialidad</strong>
            </span>
            <div className="card-body">
              <div className="row py-2 align-items-end">
                <div className="col-10">
                  <label htmlFor="fechaLlamada">Nombre especialidad:</label>
                  <input
                    className="form-control"
                    type="text"
                    id="nombreNuevaEspecialidad"
                    onChange={(e) => {
                      setNuevaEspecialidad([{ name: e.target.value }]);
                    }}
                  />
                </div>
                <div className="col-2">
                  <button
                    type="button"
                    className="btn btn-success col-12"
                    onClick={() => {
                      insertEspecialidad(nuevaEspecialidad).then(() =>
                        getEspecialidades().then((especialidades) => {
                          setEspecialidades(especialidades);
                          document.getElementById("myModal").style.display =
                            "none";
                          document.getElementById(
                            "nombreNuevaEspecialidad"
                          ).value = "";
                        })
                      );
                    }}
                  >
                    Crear especialidad
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Especialidades;
